import { render } from "./IconFolderTab.vue?vue&type=template&id=42e90ab0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFolderTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42e90ab0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42e90ab0', __exports__)) {
    api.reload('42e90ab0', __exports__)
  }
  
  module.hot.accept("./IconFolderTab.vue?vue&type=template&id=42e90ab0", () => {
    api.rerender('42e90ab0', render)
  })

}


export default __exports__